<template>
  <v-container justify-center fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <v-card class="ma-1">
          <v-toolbar color="#0044a3" dark>
            <v-app-bar-nav-icon><v-icon large>mdi-format-list-bulleted</v-icon></v-app-bar-nav-icon>
            <v-toolbar-title class="white--text">{{
              $t("automazione-logs-title")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="3">
                <v-select
                  outlined
                  dense
                  :items="assistantFilterItems"
                  item-text="name"
                  item-value="id"
                  :label="$t('automazione-filter-operator')"
                  v-model="logFilters.assistant_id"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  outlined
                  dense
                  :label="$t('automazione-filter-phone')"
                  v-model="logFilters.phone"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  outlined
                  dense
                  :items="statusFilterItems"
                  item-text="name"
                  item-value="id"
                  :label="$t('automazione-filter-status')"
                  v-model="logFilters.status"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  outlined
                  dense
                  type="date"
                  :label="$t('automazione-filter-start')"
                  v-model="logFilters.start_date"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  outlined
                  dense
                  type="date"
                  :label="$t('automazione-filter-end')"
                  v-model="logFilters.end_date"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" md="4">
                <v-alert dense outlined type="info" class="mb-2">
                  {{ $t("automazione-logs-filtered-cost") }}:
                  <strong>{{ formatUsd(logTotals.total_cost_usd) }}</strong>
                </v-alert>
              </v-col>
              <v-col cols="12" md="8" class="text-right">
                <span class="mr-4">
                  {{ $t("automazione-logs-prompt-tokens") }}: <strong>{{ logTotals.prompt_tokens }}</strong>
                </span>
                <span class="mr-4">
                  {{ $t("automazione-logs-completion-tokens") }}:
                  <strong>{{ logTotals.completion_tokens }}</strong>
                </span>
                <span>
                  {{ $t("automazione-logs-total-tokens") }}: <strong>{{ logTotals.total_tokens }}</strong>
                </span>
              </v-col>
            </v-row>

            <v-data-table
              :items-per-page="perPage"
              :must-sort="true"
              :headers="logHeaders"
              :items="logs"
              :options.sync="logOptions"
              :server-items-length="logsTotal"
              :loading="loadingLogs"
              :footer-props="dataTableFooterOptions"
              dense
            >
              <template v-slot:item.timestamp="{ item }">
                {{ item.timestamp | toLocaleDateTime }}
              </template>

              <template v-slot:item.direction="{ item }">
                {{
                  item.direction == "out"
                    ? $t("automazione-direction-out")
                    : $t("automazione-direction-in")
                }}
              </template>

              <template v-slot:item.cost_usd="{ item }">
                {{ formatUsd(item.cost_usd) }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import staticData from "../../apis/static";
import automazione from "../../apis/automazione";

export default {
  data() {
    return {
      dataTableFooterOptions: staticData.dataTableFooterOptions,
      perPage: staticData.defaultPerPage,
      loadingLogs: false,
      assistants: [],
      logs: [],
      logsTotal: 0,
      logTotals: {
        prompt_tokens: 0,
        completion_tokens: 0,
        total_tokens: 0,
        total_cost_usd: 0,
        by_conversation: []
      },
      logFilters: {
        assistant_id: null,
        phone: "",
        status: null,
        start_date: null,
        end_date: null
      },
      logOptions: {
        sortBy: ["timestamp"],
        sortDesc: [true],
        itemsPerPage: 50,
        page: 1
      },
      logHeaders: [
        {
          text: this.$t("automazione-logs-time"),
          value: "timestamp",
          sortable: true
        },
        {
          text: this.$t("automazione-logs-conversation"),
          value: "conversation_id",
          sortable: true
        },
        {
          text: this.$t("automazione-filter-operator"),
          value: "assistant_name",
          sortable: true
        },
        {
          text: this.$t("automazione-filter-phone"),
          value: "phone",
          sortable: true
        },
        {
          text: this.$t("automazione-logs-direction"),
          value: "direction",
          sortable: true
        },
        {
          text: this.$t("automazione-operator-model"),
          value: "model",
          sortable: true
        },
        {
          text: this.$t("automazione-logs-total-tokens"),
          value: "total_tokens",
          sortable: true
        },
        {
          text: this.$t("automazione-logs-cost-usd"),
          value: "cost_usd",
          sortable: true
        },
        {
          text: this.$t("automazione-logs-status"),
          value: "status",
          sortable: true
        },
        {
          text: this.$t("automazione-logs-message"),
          value: "message",
          sortable: false
        }
      ]
    };
  },

  computed: {
    assistantFilterItems() {
      return [{ id: null, name: this.$t("gbl-all-male") }, ...this.assistants];
    },

    statusFilterItems() {
      return [
        { id: null, name: this.$t("gbl-all-male") },
        { id: "sent", name: "sent" },
        { id: "received", name: "received" },
        { id: "failed", name: "failed" }
      ];
    }
  },

  watch: {
    logOptions: {
      handler() {
        this.fetchLogs();
      },
      deep: true
    },

    logFilters: {
      handler() {
        this.fetchLogs();
      },
      deep: true
    }
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      await this.fetchSetup();
      await this.fetchLogs();
    },

    fetchSetup() {
      return automazione.fetchSetup().then(result => {
        this.assistants = result.assistants;
      });
    },

    fetchLogs() {
      this.loadingLogs = true;
      let ctx = Object.assign({}, this.logOptions);
      ctx.filters = Object.assign({}, this.logFilters);
      ctx.sortBy = ctx.sortBy[0];
      ctx.sortDesc = ctx.sortDesc[0];
      ctx.perPage = this.perPage;
      ctx.currentPage = this.logOptions.page;

      return automazione
        .fetchLogs(ctx)
        .then(result => {
          this.logs = result.items;
          this.logsTotal = result.totalCount;
          this.logTotals = Object.assign(
            {
              prompt_tokens: 0,
              completion_tokens: 0,
              total_tokens: 0,
              total_cost_usd: 0,
              by_conversation: []
            },
            result.totals || {}
          );
        })
        .finally(() => {
          this.loadingLogs = false;
        });
    },

    formatUsd(value) {
      const amount = Number(value || 0);
      return "$" + amount.toFixed(6);
    }
  }
};
</script>
